import { Autocomplete, Grid, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getMeetingNoFromUnitIdApi } from "api/meeting";
import { getUnitsFromPageType } from "app/utils/meetingReduxHelpers";
import { projeEsgudumMangList } from "app/utils/appHelpers";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentMeeting } from "stores/meeting";

function MeetingInfoTab({ handleDataChange, errors }) {
    const dispatch = useDispatch();
    const authUser = useSelector(state => state.auth.authUser);
    const { data: unitList } = useSelector(state => state.unit);
    const [minMeetingNo, setMinMeetingNo] = useState(0);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [meetingObj, setMeetingObj] = useState([]);
    const [unitListData, setUnitListData] = useState(unitList);
    const pageType = useSelector(state => state.meeting.pageType);
    const authStore = useSelector(state => state.auth);

    useEffect(() => {
        if (currentMeeting.id !== undefined) {
            setMeetingObj(currentMeeting);
        } else {
            const empty_meetingObj = {
                adminUserId: authUser.id,
                meetingNo: 0,
                inst: '',
                unitId: 0,
                pdate: new Date(),
                statVideoCall: 0,
                statReview: 0,
                statVote: 0,
                statFinish: 0,
                createVideoStatus: 0,
                decisionCount: 0,
                meetingMode: 'Yüz yüze',        // default değer
                meetingUrl: '',
                meetingShortUrl: ''
            };
            dispatch(setCurrentMeeting(empty_meetingObj));
            setMeetingObj(empty_meetingObj);
        }

        let units = getUnitsFromPageType({ authStore }, pageType);

        const userRoles = authUser ? authUser.userRoles : [];
        units = projeEsgudumMangList(userRoles, units, "id");

        setUnitListData(units);
    }, [currentMeeting.id, pageType]);

    const handleChangeUnit = async (newValues) => {
        const nextMeetingNoData = await getMeetingNoFromUnitIdApi(newValues.unitId);
        nextMeetingNoData.data[0].nextMeetingNo === null ? setMinMeetingNo(1) : setMinMeetingNo(nextMeetingNoData.data[0].nextMeetingNo);

        const updatedMeetingObj = {
            ...meetingObj,
            ...newValues,
            meetingNo: nextMeetingNoData.data[0].nextMeetingNo
        };

        setMeetingObj(updatedMeetingObj);
        dispatch(setCurrentMeeting(updatedMeetingObj));
        handleDataChange(updatedMeetingObj);
    };

    const handleChange = (field, value) => {
        const updatedMeetingObj = {
            ...meetingObj,
            [field]: value
        };
        setMeetingObj(updatedMeetingObj);
        dispatch(setCurrentMeeting(updatedMeetingObj));
        handleDataChange(updatedMeetingObj);
    };

    return (
        <>
            <Grid container marginY={1} spacing={1} rowSpacing={1}>

                <Grid item xs={12} sm={12} md={6} lg={4} >
                    <FormLabel component="legend">Kurul/Kol/Komisyon</FormLabel>
                    <Autocomplete
                        id="autocomplete"
                        options={unitListData}
                        value={unitListData.find(option => option.id === meetingObj.unitId) || null}
                        onChange={(event, newValue) => {
                            const newValues = {};
                            if (newValue) {
                                newValues.unitId = newValue.id;
                                newValues.unit = newValue.name;
                                newValues.inst = newValue.inst;
                            } else {
                                newValues.unitId = 0;
                                newValues.unit = '';
                                newValues.inst = '';
                            }
                            handleChangeUnit(newValues);
                        }}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Kurul/Kol/Komisyon seçiniz"
                                required
                                error={!!errors.unitId}
                                helperText={errors.unitId || ""}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={2}>
                    <FormLabel component="legend">Toplantı No</FormLabel>
                    <TextField
                        variant="outlined"
                        placeholder="Toplantı No Giriniz"
                        fullWidth
                        type="number"
                        InputProps={{
                            inputProps: { min: minMeetingNo },
                        }}
                        value={meetingObj.meetingNo}
                        onChange={(e) => handleChange('meetingNo', Number(e.target.value))}
                        required
                        error={!!errors.meetingNo}
                        helperText={errors.meetingNo || ""}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"tr"}>
                        <FormLabel component="legend">Tarih</FormLabel>
                        <DateTimePicker
                            placeholder="Tarih Seçiniz"
                            value={meetingObj.pdate}
                            onChange={(newValue) => handleChange('pdate', moment(new Date(newValue)).format('YYYY-MM-DD HH:mm:ss'))}
                            renderInput={(params) => <TextField {...params} />}
                            required
                            error={!!errors.pdate}
                            helperText={errors.pdate || ""}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={3}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Toplantı Şekli</FormLabel>
                        <RadioGroup
                            row
                            name="meetingMode"
                            value={meetingObj.meetingMode || 'Yüz yüze'}
                            onChange={(e) => handleChange('meetingMode', e.target.value)}
                        >
                            <FormControlLabel value="Yüz yüze" control={<Radio />} label="Yüz yüze" />
                            <FormControlLabel value="Çevrim içi" control={<Radio />} label="Çevrim içi" />
                            <FormControlLabel value="Hibrit" control={<Radio />} label="Hibrit" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

            </Grid>
        </>
    );
}

export default MeetingInfoTab;
